import { FeaturedList } from "@/@types";
import { ApiClient } from "../../ApiClient";
import { getFeaturedListResponse } from "../schema/GetFeaturedListResponse";
import { mapFeaturedList } from "../../mappers/promotions/FeaturedListMapper";

export const getFeaturedList = async (): Promise<FeaturedList[]> => {
    const client = ApiClient.getInstance()

    const response = await client.get<getFeaturedListResponse>('home/featureds')

    const mappedResponse = mapFeaturedList(response.data)

    return mappedResponse;
}